import { Link } from "react-router-dom";
import styled from "styled-components";

export const LinkCustom = styled(Link)`
  text-decoration: none;
  color: #4b4b4b !important;

  &:hover {
    text-decoration: underline;
  }
`;
